import { IKnmPmSubjectTypeSelectOption } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormResultDecision';

import { KnmResultDecisionSubjectTypesEnum } from '../enums/KnmResultDecisionSubjectTypesEnum';

const resultDecisionSubjectTypeOptions: IKnmPmSubjectTypeSelectOption[] = [
  {
    id: 'CONTROLLING_SUBJECT',
    value: KnmResultDecisionSubjectTypesEnum.CONTROLLING_SUBJECT,
    label: 'Контролируемое лицо',
  },
  {
    id: 'FOUNDER',
    value: KnmResultDecisionSubjectTypesEnum.FOUNDER,
    label: 'Учредитель',
  },
];

export const convertSubjectType = (
  subjectType: KnmResultDecisionSubjectTypesEnum | null,
): IKnmPmSubjectTypeSelectOption<string | number> | undefined => {
  if (!subjectType) {
    return undefined;
  }

  return resultDecisionSubjectTypeOptions.find(option => option.value === subjectType);
};
